<ph-dialog [open]="open" size="md" [heading]="heading" [icon]="icon" [noClose]="saving" (ph-close)="close()">
    <ph-stack>
        <app-file-upload [accept]="accept"
                         [multiple]="multiple"
                         [maxBytes]="maxBytes"
                         [maxFiles]="maxFiles"
                         [hint]="hint"
                         [disabled]="saving"
                         [(files)]="files"></app-file-upload>
        <ph-alert *ngIf="saveError" status="error" variant="lighter">{{ saveError }}</ph-alert>
        <ng-content></ng-content>
    </ph-stack>

    <ph-actions slot="footer">
        <ph-button variant="secondary" mode="filled" type="button" [disabled]="saving" (click)="close()">Cancel</ph-button>
        <ph-button variant="primary" mode="filled" type="button" [disabled]="!files.length" [loading]="saving" (click)="submit()">{{ buttonLabel }}</ph-button>
    </ph-actions>
</ph-dialog>
